// extracted by mini-css-extract-plugin
export default {"container":"Map--container--7WA0w","notSupported":"Map--notSupported--xbRkD"};